import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getBalance } from '../../actions/balanceActions'
import { getEvents, setParticipation, dispatchGamesList } from "../../actions/eventsAction";
import api from '../../api';
import { $t } from '../../utils/translate';
import MessageBox from '../MessageBox';
import { getUrlParamQueries, formatCurrency, windowResize, scrollView } from '../../utils';
class BetFooter extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            modalShow: false,
            message: '',
            headermessage: 'Message',
            betSuccess: false,
            find_out_more: '',
            balance: 0,
            participationBets: [],
            running:false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.balance !== prevProps.balance) {
            if (typeof this.props.balance != "undefined") {
                if (this.props.balance.length > 0) {
                    this.setState({ balance: this.props.balance[0].balance, participationBets: this.props.balance[0].participationBets ? this.props.balance[0].participationBets : [] });
                }
            }
        }
        windowResize();
    }

    reset() {
        // this.props.getEvents();
        if (this.props.participated) { return false; }
        let gameType = this.props.gameType;
        if (this.props.isMulti !== undefined) { gameType = 'multi-market'; }

        let gamesList = [...this.props.gamesList[gameType]];
        for (let i = 0; i < gamesList.length; i++) {
            // if (gamesList[i].id == gameid) {
                gamesList[i].selectedballs = [];
            // }
        }
        let wholeGamesList = Object.assign({}, this.props.gamesList);

        wholeGamesList[gameType] = gamesList;
        this.props.dispatchGamesList(wholeGamesList);
    }

    goHome() {

    }

    picknow(e) {
        if(this.state.running){return false;}
        this.setState({running:true});
        let bets = [];
        let item = this.props.gamesList[this.props.gameType];
        for (let j = 0; j < item.length; j++) {
            if (item[j].selectedballs.length > 0) {
                for (let b = 0; b < item[j].selectedballs.length; b++) {
                    bets.push({
                        "competition_id": item[j].competition_id,
                        "competition_event_market_id": item[j].selectedballs[b].split('|')[0],
                        "event_market_outcome_id": item[j].selectedballs[b].split('|')[1]
                    });
                }
            }
        }

        if (bets.length < item.length) {
            this.setState({ message: 'Minimum of ' + item.length + ' bets required.', headermessage: "Confirm Bet" }, this.setModalShow(true));
            this.setState({running:false});
            scrollView();
            return false;
        }

        let data = {
            "transaction": {
                "customer_id": getUrlParamQueries()['customer']
            },
            "bets": bets
        };

        api.picknow(data).then(r => {
            if (r.code == 200) {
                // this.props.setParticipation(true);
                this.props.getBalance();
                this.reset();
                this.setState({ headermessage: "Success" }, this.setModalShow(true));
            } else {
                this.setState({ message: r.message, headermessage: "Already Participated" }, this.setModalShow(true));
            }
            this.setState({running:false});
            scrollView();
        });
        
    }

    setModalShow(show) {
        this.setState({ modalShow: show }, () => {
            var html = document.documentElement;
            var doc_height = html.offsetHeight;
            if (doc_height < 500) {
                windowResize(500 - doc_height);
            }
            if (show) {
                let element = document.getElementsByClassName("modal-message")[0];
                document.documentElement.scrollTop = document.body.scrollTop = element.scrollTop;
            }
        });
    }

    render() {
        return (
            <div>
                <Row>
                    <div className="ml-auto text-info-odds">
                        *Odds are indicative only and are subject to change.
                    </div> 
                </Row>
                <Row className="no-gutters mx-0 mt-0 mb-0 p-2">
                    <Col md="1"></Col>
                    <Col md="7"></Col>
                    <Col md="4">
                        {(this.props.gamesList != '' && Object.keys(this.props.gamesList).length > 0) &&
                            <div>
                                <Button disabled={Object.keys(this.state.participationBets).length > 0 || getUrlParamQueries()['loggedIn'] != "true" || Number(this.state.balance) == 0} onClick={() => { this.picknow() }} className="rounded-0 w-100 text-white px-5 ml-2 btn-info btn-place-bet btn-general d-none" variant="info">{$t('text_place_bet', 'default', this.props.messages)}</Button>
                            </div>
                        }
                    </Col>
                </Row>
                {(this.props.gamesList != '' && Object.keys(this.props.gamesList).length > 0) &&
                    <MessageBox jackpot={(this.props.gamesList["multi-market"][0]['jackpot']).toLocaleString('en')} show={this.state.modalShow} onHide={() => this.setModalShow(false)} message={this.state.message} headermessage={this.state.headermessage} />
                }
                {(this.props.gamesList != '' && Object.keys(this.props.gamesList).length > 0) &&
                    <Row className="bet-btn-wrapper">
                        <Button disabled={this.state.running || getUrlParamQueries()['loggedIn'] != "true" || Number(this.state.balance) == 0} onClick={() => { this.picknow() }} className="bet-img m-auto" variant="info">
                           {!this.state.running? <span>Submit</span> : <span>Sending...</span>}
                    </Button>

                        <div className="ml-auto">

                            <Button onClick={() => { this.reset() }} className="btn-reset btn-default">
                                {/* {$t('text_reset', 'default', this.props.messages)} */}
                                {/* Reset */}
                                <img src="/assets/icons/refreshing.svg" title="Reset" className="img-icon-btn" />
                                </Button>
                            {/* <Button onClick={() => { this.goHome() }} className="btn-home btn-default">
                                

                                <img src="/assets/icons/icon_home_1.svg" title="Go back home" className="img-icon-btn" />
                            </Button> */}
                        </div>
                    </Row>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        messages: state.messageReducer.messages,
        gamesList: state.eventsReducer.gamesList,
        balance: state.balanceReducer.balance
    }
}

export default connect(mapStateToProps, { getEvents, setParticipation, dispatchGamesList, getBalance })(BetFooter);



// WEBPACK FOOTER //
// ./components/BetFooter/index.js